import { RouteConfig } from 'vue-router';

export const pwaDebugRoutes: RouteConfig[] = [
  {
    name: 'pwa-debug',
    path: '/pwa-debug',
    component: () => import('./PwaDebugTest.vue'),
    meta: {
      title: 'PWA Debug Tool',
      requiresAuth: false
    }
  }
];